import React from 'react';
import { Link } from 'react-router-dom';

const NAV_LINKS = [
  { to: '/contact', label: 'Contact' },
  { to: '/privacy-policy', label: 'Privacy' },
  { to: '/terms', label: 'Terms' },
  { to: '/DMCA', label: 'DMCA' },
  { to: '/about', label: 'About' },
];

const SOCIALS = [
  { href: 'https://www.facebook.com/thegamezone.fun', label: 'Facebook', path: 'M25 3C12.861 3 3 12.861 3 25c0 11.019 8.128 20.138 18.713 21.729L22.861 46.9V29.566h-5.197v-3.52h5.197v-4.673c0-2.878.691-4.773 1.834-5.962 1.143-1.19 2.833-1.789 5.184-1.789 1.88 0 2.61.114 3.306.2v2.88h-2.447c-1.389 0-2.528.775-3.119 1.807-.592 1.032-.777 2.264-.777 3.52v4.017h6.122l-.545 3.52h-5.577V46.93l1.134-.154C38.714 45.319 47 36.127 47 25 47 12.861 37.138 3 25 3z' },
  { href: 'https://x.com/thegamezon', label: 'Twitter / X', path: 'M34.219 5.469C28.238 5.469 23.375 10.332 23.375 16.313c0 .358.09.71.125 1.062-7.395-.708-13.934-4.27-18.375-9.719a9.35 9.35 0 00-1.063 3.563c0 2.403.86 4.602 2.188 6.406-.258-.113-.54-.175-.781-.313-.309-.163-.68-.156-.98.024-.302.179-.485.503-.489.851L4 18.313c0 3.683 1.906 6.882 4.719 8.843-.031-.003-.063.016-.094.007-.344-.059-.69.164-.922.426-.231.261-.305.625-.203.957 1.117 3.472 3.969 6.125 7.5 7.094C12.188 37.254 8.927 38.238 5.406 38.238c-.762 0-1.492-.04-2.219-.125-.469-.063-.918.21-1.074.656-.156.445.019.941.421 1.188 4.512 2.894 9.867 4.594 15.625 4.594 9.332 0 16.652-3.899 21.563-9.469 4.91-5.57 7.469-12.805 7.469-19.563 0-.285-.024-.563-.032-.844 1.832-1.403 3.47-3.046 4.75-4.968a1 1 0 00-.77-1.563c-.516-.23-1.117-.206-1.656.023.711-.95 1.32-1.973 1.688-3.125a1 1 0 00-1.336-1.25C44.449 8.406 42.558 9.117 40.563 9.55 38.625 7.738 36.074 5.469 33.219 5.469z' },
  { href: 'https://www.instagram.com/thegamezone.fun/', label: 'Instagram', path: 'M16 3C8.832 3 3 8.832 3 16v18C3 41.168 8.832 47 16 47h18c7.168 0 13-5.832 13-13V16C47 8.832 41.168 3 34 3H16zm0 2h18c6.086 0 11 4.914 11 11v18c0 6.086-4.914 11-11 11H16C9.914 45 5 40.086 5 34V16C5 9.914 9.914 5 16 5zm21 6a2 2 0 100 4 2 2 0 000-4zM25 14c-6.063 0-11 4.937-11 11s4.937 11 11 11 11-4.937 11-11-4.937-11-11-11zm0 2c4.982 0 9 4.018 9 9s-4.018 9-9 9-9-4.018-9-9 4.018-9 9-9z' },
];

const Footer = () => (
  <footer className="py-6 px-5 bg-secondary-theme border-t-theme">
    <div className="max-w-4xl mx-auto">
      <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-2 no-underline">
          <img src="/logo.png" alt="TheGameZone" className="w-7 h-7 rounded-lg" />
          <span className="font-extrabold text-base font-sora gradient-text">TheGameZone</span>
        </Link>

        <nav className="flex flex-wrap gap-1 justify-center">
          {NAV_LINKS.map(({ to, label }) => (
            <Link key={to} to={to}
              className="text-xs font-semibold px-2.5 py-1 rounded-md transition-colors no-underline text-dim hover:text-main hover:bg-hover-theme">
              {label}
            </Link>
          ))}
        </nav>

        <div className="flex gap-2">
          {SOCIALS.map(({ href, label, path }) => (
            <a key={label} href={href} target="_blank" rel="noopener noreferrer" aria-label={label}
              className="w-8 h-8 rounded-lg flex items-center justify-center transition-colors bg-hover-theme hover:bg-blue-500/20">
              <svg viewBox="0 0 50 50" width="16" height="16" fill="var(--text-secondary)">
                <path d={path} />
              </svg>
            </a>
          ))}
        </div>
      </div>

      <div className="mt-4 pt-3 text-center text-xs text-dim border-t-theme">
        © 2026 TheGameZone.fun — All Rights Reserved
      </div>
    </div>
  </footer>
);

export default Footer;
